// extracted by mini-css-extract-plugin
export default {"donutContainer":"DemographicsDonuts_donutContainer__wPRNQ","donutGroup":"DemographicsDonuts_donutGroup__ZPM8K","boxDonut":"DemographicsDonuts_boxDonut__BKSdM"};